export var fargeFjell = '#002776';
export var fargeFjell70 = '#4d689f';
export var fargeFjell30 = '#b3bed6';
export var fargeVann = '#005aa4';
export var fargeVann70 = '#4d8cbf';
export var fargeVann30 = '#b3cee4';
export var fargeSand = '#f8e9dd';
export var fargeSand70 = '#faf0e7';
export var fargeSand30 = '#fdf8f5';
export var fargeFrost = '#7eb5d2';
export var fargeFrost70 = '#a5cbe0';
export var fargeFrost30 = '#d8e9f2';
export var fargeSyrin = '#d3d3ea';
export var fargeSyrin70 = '#e0e0f0';
export var fargeSyrin30 = '#f2f2f9';
export var fargeMyrull = '#fae4e0';
export var fargeMyrull70 = '#fcece9';
export var fargeMyrull30 = '#fef7f6';
export var fargeVillblomst = '#ee8d9c';
export var fargeVillblomst70 = '#f3afba';
export var fargeVillblomst30 = '#fadde1';
export var fargeNordlys = '#33af85';
export var fargeNordlys70 = '#70c7aa';
export var fargeNordlys30 = '#c2e7da';
export var fargeLyng = '#873953';
export var fargeLyng70 = '#ab7487';
export var fargeLyng30 = '#dbc4cb';
export var fargeBaer = '#db3335';
export var fargeBaer70 = '#e67072';
export var fargeBaer30 = '#f4c2c2';
export var fargeSkog = '#00754e';
export var fargeSkog70 = '#4d9e83';
export var fargeSkog30 = '#b3d6ca';
export var fargeMulte = '#f8b181';
export var fargeMulte70 = '#fac8a7';
export var fargeMulte30 = '#fde8d9';
export var fargeSol = '#dc8000';
export var fargeSol70 = '#e7a64d';
export var fargeSol30 = '#f5d9b3';
export var fargeNatt = '#001032';
export var fargeSvart = '#020a0a';
export var fargeKoksgraa = '#323232';
export var fargeMoerkgraa = '#676767';
export var fargeGraa = '#adadad';
export var fargeLysgraa = '#d8d8d8';
export var fargeMoerkvarmgraa = '#848383';
export var fargeVarmgraa = '#9b9797';
export var fargeLysvarmgraa = '#d7d2cb';
export var fargeHvit = '#fff';
